export const REFUND_SUCCESS_ADD = "REFUND_SUCCESS_ADD";
export const REFUND_SUCCESS_EDIT = "REFUND_SUCCESS_EDIT";
export const BANK_LIST_RESULT = "BANK_LIST_RESULT";
export const LIST_USER_REFUNDS = "LIST_USER_REFUNDS";
export const REQUEST_FOR_REFUND_LIST = "REQUEST_FOR_REFUND_LIST";
export const ITEM_SELECTED_FOR_EDIT_REFUND = "ITEM_SELECTED_FOR_EDIT_REFUND";
export const MODAL_STATUS_TOGGLE = 'MODAL_STATUS_TOGGLE';
export const MOBILE_LOGIN = "MOBILE_LOGIN";
export const ALERT_MESSENGER = "ALERT_MESSENGER";
export const Get_OSTAM = "Get_OSTAM";
export const Get_SHAR = "Get_SHAR";
export const Get_COUNTRY = "Get_COUNTRY"
export const SIGN_REQUEST = "SIGN_REQUEST";  
